import { createStateContext } from 'react-use';

import { IStreetData } from 'lib/types/api';

export const [useStreetContext, StreetContextProvider] =
    createStateContext<IStreetData | null>(null);
